import { HttpClientModule } from '@angular/common/http';
// File: cgp.module.ts
// Author: Joseph M Diaz
// Date: 6/2/2017
// Desc: CGP module
// Other Contributors:

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { CgpApiService } from '../modules/cgp-api';
import { CgpAppBarModule } from './shared/cgp-app-bar/cgp-app-bar.module';
import { CgpSidenavModule } from './shared/cgp-sidenav/cgp-sidenav.module';
import { CgpFooterComponent } from './shared/cgp-footer/cgp-footer.component';
import { CgpAlertDialogModule } from './shared/cgp-alert-dialog/cgp-alert-dialog.module';
import { CgpConfirmationDialogModule } from './shared/cgp-confirmation-dialog/cgp-confirmation-dialog.module';
import { CgpBreadcrumbsModule } from './shared/cgp-breadcrumbs/cgp-breadcrumbs.module';
import { CgpSnackbarModule } from './shared/cgp-snackbar/cgp-snackbar.module';
import { CgpIdleModule } from './shared/cgp-idle/cgp-idle.module';
import { CgpUserProfileDialogModule } from './shared/cgp-user-profile-dialog/cgp-user-profile-dialog.module';
import { CgpComponentBrowserModule } from './shared/cgp-component-browser/cgp-component-browser.module'
import { CgpAppCardModule } from './shared/cgp-app-card/cgp-app-card.module';
import { CgpCheckAllModule } from './shared/cgp-check-all/cgp-check-all.module';
import { CgpNotificationMenuModule } from './shared/cgp-notification-menu/cgp-notification-menu.module';

@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        HttpClientModule,
        CgpAlertDialogModule,
        CgpSidenavModule,
        CgpConfirmationDialogModule,
        CgpBreadcrumbsModule,
        CgpSnackbarModule,
        CgpAppBarModule,
        CgpIdleModule,
        CgpComponentBrowserModule,
        CgpCheckAllModule,
        CgpAppCardModule,
        CgpNotificationMenuModule
    ],
    declarations: [
        CgpFooterComponent
    ],
    providers: [
        CgpApiService
    ],
    exports: [
        RouterModule,
        CgpAlertDialogModule,
        CgpConfirmationDialogModule,
        CgpUserProfileDialogModule,
        CgpBreadcrumbsModule,
        CgpSnackbarModule,
        CgpAppBarModule,
        CgpSidenavModule,
        CgpFooterComponent,
        CgpComponentBrowserModule,
        CgpCheckAllModule,
        CgpAppCardModule,
        CgpNotificationMenuModule
    ]
})
export class CgpModule { }